module.exports = __webpack_public_path__ + "img/auction-sim-browse-1.70bf9e4b.png";